export var LoanApplication;
(function (LoanApplication) {
    var EmploymentType;
    (function (EmploymentType) {
        EmploymentType["land"] = "land";
        EmploymentType["sea"] = "sea";
    })(EmploymentType = LoanApplication.EmploymentType || (LoanApplication.EmploymentType = {}));
    var EmploymentChannel;
    (function (EmploymentChannel) {
        EmploymentChannel["agency"] = "agency";
        EmploymentChannel["directHire"] = "direct_hire";
        EmploymentChannel["balikManggagawa"] = "balik_manggagawa";
    })(EmploymentChannel = LoanApplication.EmploymentChannel || (LoanApplication.EmploymentChannel = {}));
    var OfwStatusOption;
    (function (OfwStatusOption) {
        OfwStatusOption["agency"] = "agency";
        OfwStatusOption["directHire"] = "direct_hire";
        OfwStatusOption["balikManggagawa"] = "balik_manggagawa";
    })(OfwStatusOption = LoanApplication.OfwStatusOption || (LoanApplication.OfwStatusOption = {}));
    LoanApplication.Interest = (_a = {},
        _a[EmploymentType.land] = 0.035,
        _a[EmploymentType.sea] = 0.03,
        _a);
    LoanApplication.LoanFee = (_b = {},
        _b[EmploymentType.land] = 0.125,
        _b[EmploymentType.sea] = 0.13,
        _b);
    LoanApplication.GracePeriod = (_c = {},
        _c[EmploymentType.land] = 1,
        _c[EmploymentType.sea] = 1,
        _c);
    LoanApplication.CheckFee = 300.00;
    LoanApplication.LoanAmountBounds = (_d = {},
        _d[EmploymentType.land] = { min: 30000, max: 250000, step: 5000, default: 30000 },
        _d[EmploymentType.sea] = { min: 30000, max: 250000, step: 5000, default: 30000 },
        _d);
    LoanApplication.LoanDurationBounds = (_e = {},
        _e[EmploymentType.land] = { min: 6, max: 12, step: 1, default: 6 },
        _e[EmploymentType.sea] = { min: 3, max: 8, step: 1, default: 3 },
        _e);
    // Copied from old BB website; equation credit to Huyen
    function getMonthlyAmortization(principal, tenor, interestRate, loanFeeRate, gracePeriod, checkFee) {
        if (checkFee === void 0) { checkFee = 175.00; }
        return Math.round(principal / tenor
            + checkFee / tenor
            + principal * loanFeeRate / tenor
            + principal * interestRate * (tenor + gracePeriod) * 30 * (12 / 365) / tenor);
    }
    LoanApplication.getMonthlyAmortization = getMonthlyAmortization;
    var _a, _b, _c, _d, _e;
})(LoanApplication || (LoanApplication = {}));
